import React, { useState } from "react"
import { Drawer, Button, Card, Descriptions, Divider, Tabs, Row, Col, Spin, Menu, Dropdown, message } from "antd"
import {
  GENDER_ENUM,
  ORDER_STATUS_MAP,
  ORDER_EXECUTION_STATUS_MAP,
  ORDER_STATUS_TO_PAY,
  ORDER_STATUS_TO_CONFIRM,
  ORDER_STATUS_CANCEL,
  ORDER_STATUS_SUCCESS,
  ORDER_EXECUTION_STATUS_SUCCESS, ORDER_STATUS_PAID,
  PRODUCT_CATEGORY_DRUG,
  PRODUCT_CATEGORY_SERVICE,
  ORDER_REFUNT_STATUS_MAP,
  ORDER_REFUNT_STATUS_FULL_REFUND,
  ORDER_TYPE_ENUM,
  ORDER_SOURCE
} from '@/utils/consts'
import { updateAssistant as doUpdateAssistant } from '@/services/order'
import { isFunction } from 'lodash'
import styles from './index.less'
import moment from 'moment'
import OrderTable from './OrderTable'
import ReserveInfo from './ReserveInfo'
import ReceivablesInfo from './ReceivablesInfo'
import LogisticsInfo from './LogisticsInfo'
import RefundInfo from './RefundInfo'
import { confirm } from '@/utils/utils'
import UpgradeOrderInfo from './UpgradeOrderInfo'
import ScanCodePayment from './ScanCodePayment'
import UpdateSource from "./UpdateSource"
import UpdateAssistant from "./UpdateAssistant"

const { TabPane } = Tabs

const OrderDrawer = ({
  info,
  employees,
  loaded,
  payments,
  reservePagination,
  onReservePageNoChange,
  paymentPagination,
  logistics,
  logisticsPagination,
  onPaymentPageNoChange,
  reserveList,
  upgradeList,
  receivablesList,
  onEdit,
  refundList,
  reserveStatus,
  onReserveEdit,
  onLogisticsEdit,
  onReceivablesEdit,
  onClose,
  onEditStatus,
  onAction,
  onLoadData,
  fetchingOrderDetail,
  onPaymentDelete,
  onCancelOrder,
  onCustomerDetail,
  onRefundEdit,
  loading,
  dispatch,
  merchantCode,
  paymentReturnInfo,
  paymentStatus,
  queryPaymentStatus,
  scanCodePaymentVisible,
  onContinuePay,
  onCancelPayment,
  location,
  onSuccess,
  source = 'order',
  ...drawerProps
}) => {
  const orderItemVos = info.orderItemVos || []
  const drugOrderItemVos = info.drugOrderItemVos || []

  const [updateSourceVisible, setUpdateSourceVisible] = useState(false)
  const [updateAssistant, setUpdateAssistant] = useState(false)

  const handleClick = ({ key }) => {
    // 新增预约
    if (key === '1' && info.category === PRODUCT_CATEGORY_SERVICE) {
      onReserveEdit('add', {})
      return
    }

    // 新增发货
    if (key === '1' && info.category === PRODUCT_CATEGORY_DRUG) {
      onLogisticsEdit('add', {})
      return
    }

    if (key === '2') {
      onReceivablesEdit('add', {})
      return
    }

    if (key === '3') {
      confirm({
        title: '取消提醒',
        content: '确认要取消此订单吗？'
      }).then(() => {
        onCancelOrder(info)
      })
    }

    if (key === '4') {
      onRefundEdit('add', { customerName: info.customerName, customerId: info.customerId, createdByUser: info.createdByUser })
    }
  }

  // const reservationDisabled = [ORDER_STATUS_CANCEL, ORDER_STATUS_SUCCESS, ORDER_STATUS_TO_CONFIRM].indexOf(info.status) > -1
  //   || info.executionStatus === ORDER_EXECUTION_STATUS_SUCCESS 
  const reservationDisabled = info.reservationItemCount === 0 || [ORDER_STATUS_CANCEL, ORDER_STATUS_SUCCESS, ORDER_STATUS_TO_CONFIRM].indexOf(info.status) > -1
    || info.executionStatus === ORDER_EXECUTION_STATUS_SUCCESS
  const paymentDisabled = [ORDER_STATUS_CANCEL, ORDER_STATUS_SUCCESS, ORDER_STATUS_TO_CONFIRM, ORDER_STATUS_PAID].indexOf(info.status) > -1
  const cancelDisabled = info.isReservation || info.status !== ORDER_STATUS_TO_PAY
  const refundDisabled = info.status === ORDER_STATUS_TO_CONFIRM || info.status === ORDER_STATUS_SUCCESS || info.status === ORDER_STATUS_TO_PAY || info.refundStatus === ORDER_REFUNT_STATUS_FULL_REFUND
  // const refundDisabled = 

  const menu = (
    <Menu onClick={handleClick}>
      {info.category === PRODUCT_CATEGORY_DRUG && <Menu.Item key='1'>新增发货</Menu.Item>}
      {/* info.category === PRODUCT_CATEGORY_SERVICE && <Menu.Item key='1' disabled={reservationDisabled}>新增预约</Menu.Item> */}
      {/* <Menu.Item key='2' disabled={paymentDisabled}>新增收款</Menu.Item> */}
      {/* <Menu.Item key='4' disabled={refundDisabled}>退款</Menu.Item> */}
      <Menu.Item key='3' disabled={cancelDisabled}>取消</Menu.Item>
    </Menu>
  )

  const onTabsChange = e => {
    if (e === '2') {
      if (!loaded.reserve) {
        setTimeout(() => {
          onLoadData('reserve', { id: info.id })
        }, 300)
      }
    }
  }

  const title = (
    <div className={styles.drawerHeader}>
      <div className="userInfo">
        <Row gutter={16}>
          <Col span={16}>
            <span><span style={{ color: 'rgba(0, 0, 0, .5)' }}>订单编码：</span>{info.code}</span>
          </Col>
          <Col span={8}>
            <span><span style={{ color: 'rgba(0, 0, 0, .5)' }}>姓名：</span>
              {source !== 'task' && <a onClick={() => onCustomerDetail(info)}>{info.customerName}</a>}
              {source === 'task' && info.customerName}
            </span>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={8}>
            <span><span style={{ color: 'rgba(0, 0, 0, .5)' }}>性别：</span>{info.customerGender && GENDER_ENUM.find(_ => _.value === info.customerGender).label}</span>
          </Col>
          <Col span={8}>
            <span><span style={{ color: 'rgba(0, 0, 0, .5)' }}>年龄：</span>{info.customerAge ? `${info.customerAge}岁` : undefined}</span>
          </Col>
          <Col span={8}>
            <span><span style={{ color: 'rgba(0, 0, 0, .5)' }}>电话: </span>{info.customerPhone}</span>
          </Col>
        </Row>
      </div>
      {source !== 'task' && <div className="operation">
        {info.status === ORDER_STATUS_TO_CONFIRM && <Button type="primary" shape="circle" icon="edit" onClick={() => onEdit(info)} />}
        <Button type="primary" disabled={paymentDisabled} onClick={() => handleClick({ key: '2' })}>新增收款</Button>
        {info.category === PRODUCT_CATEGORY_SERVICE && <Button type="primary" disabled={reservationDisabled} onClick={() => handleClick({ key: '1' })}>新增预约</Button>}
        <Dropdown overlay={menu} placement="bottomRight">
          <Button icon="more" shape="circle" />
        </Dropdown>
        {/* <Button shape="circle" icon="swap"></Button> */}
        <Button shape="circle" icon="close" onClick={() => onClose()} ></Button>
      </div>}
      {source === 'task' && <div className="operation">
        <Button shape="circle" icon="close" onClick={() => onClose()} ></Button>
      </div>}
    </div>
  )

  const ScanCodePaymentProps = {
    visible: scanCodePaymentVisible,
    loading,
    dispatch,
    merchantCode,
    paymentReturnInfo,
    paymentStatus,
    queryPaymentStatus,
    info,
    location,
    onCancel: () => { dispatch({ type: 'orderList/updateState', payload: { scanCodePaymentVisible: false } }) },
    onCancelPayment,
  }

  const updateSourceProps = {
    visible: updateSourceVisible,
    loading,
    dispatch,
    info,
    onCancel: () => { setUpdateSourceVisible(false) },
    onOk: (data) => {
      dispatch({ type: 'orderList/updateOrderSource', payload: data }).then(() => {
        setUpdateSourceVisible(false)
        dispatch({ type: 'orderList/queryOrderDetail', payload: info.id })
      })
    }
  }

  const fetchUpdateAssistant = async (payload) => {
    const { data, code } = await doUpdateAssistant(payload)
    if (code === 0) {
      message.success('修改协助心理师成功！')
      setUpdateAssistant(false)
      dispatch({ type: 'orderList/queryOrderDetail', payload: info.id })
      isFunction(onSuccess) && onSuccess(info.id)
    }
  }

  const updateAssistantProps = {
    visible: updateAssistant,
    loading,
    dispatch,
    employees,
    info,
    onCancel: () => { setUpdateAssistant(false) },
    onOk: (data) => {
      // dispatch({ type: 'orderList/updateAssistantModel', payload: data }).then(() => {
      //   setUpdateAssistant(false)
      //   dispatch({ type: 'orderList/queryOrderDetail', payload: info.id })
      // })
      fetchUpdateAssistant(data)
    }
  }

  return (
    <Drawer {...drawerProps}
      onClose={onClose}
      title={title}
      onClick={(e) => { e.stopPropagation() }}
    >
      <Spin spinning={fetchingOrderDetail}>
        <div className={styles.drawerContent}>
          <Card bordered={false}>
            <Descriptions column={4}>
              <Descriptions.Item label="订单状态">
                <span className={info.status}>{ORDER_STATUS_MAP[info.status]}</span>
              </Descriptions.Item>
              <Descriptions.Item label="执行状态">
                <span className={`executionStatus${info.executionStatus}`}>{ORDER_EXECUTION_STATUS_MAP[info.executionStatus]}</span>
              </Descriptions.Item>
              <Descriptions.Item label="退款状态">
                <span className={`refund${info.refundStatus}`}>{ORDER_REFUNT_STATUS_MAP[info.refundStatus]}</span>
              </Descriptions.Item>
              <Descriptions.Item label="订单类型">
                <span>{info.type && (ORDER_TYPE_ENUM.find(_ => _.value === info.type) || {}).label}</span>
              </Descriptions.Item>
              <Descriptions.Item label="下单日期">{info.orderDate ? moment(info.orderDate).format('YYYY-MM-DD') : undefined}</Descriptions.Item>
              <Descriptions.Item label="订单来源">{info.source ? ORDER_SOURCE[info.source] : undefined} {localStorage.getItem('fulcrum-ancare-role-code') === 'ROLE_CLINIC_ADMIN' && source === 'order' && <Button onClick={() => { setUpdateSourceVisible(true) }} type='link'>编辑</Button>}</Descriptions.Item>
              <Descriptions.Item label="创建人">{(info.creatorUser || {}).nickname}</Descriptions.Item>
              <Descriptions.Item label="成单人">{(info.createdByUser || {}).nickname}</Descriptions.Item>
              <Descriptions.Item label="协助心理师">
                {(info.assistantCreatedByUser || {}).nickname}
                {
                  // source === 'order' &&
                  <Button onClick={() => { setUpdateAssistant(true) }} type='link'>编辑</Button>
                }
              </Descriptions.Item>
              <Descriptions.Item label="心理顾问">{(info.consultantDoctor || {}).nickname}</Descriptions.Item>
              <Descriptions.Item label="私人管家">{(info.personalDoctor || {}).nickname}</Descriptions.Item>
              <Descriptions.Item label="商品原价">{info.originAmount || info.amount}元</Descriptions.Item>
              <Descriptions.Item label="订单总金额">{info.amount}元</Descriptions.Item>
              <Descriptions.Item label="订单整体折扣">{info.discount ? (info.discount * 100).toFixed(2) + '%' : info.discount}</Descriptions.Item>
              <Descriptions.Item label="订单应收金额">{info.actualAmount}元</Descriptions.Item>
              <Descriptions.Item label="订单实收金额">{info.paidAmount && info.paidAmount.toFixed(2)}元</Descriptions.Item>
              {/*<Descriptions.Item label="已收金额">{info.amountReceived ? `${info.amountReceived}元` :
               undefined}</Descriptions.Item>
              <Descriptions.Item label="已确认金额">{info.amountDetermined ? `${info.amountDetermined}元` : undefined}</Descriptions.Item>
              **/}
              {/* <Descriptions.Item label="订单升单金额">{info.riseAmount}元</Descriptions.Item>
              <Descriptions.Item label="升单备注">{info.riseReason}</Descriptions.Item> */}
              <Descriptions.Item label="订单退款金额">{info.refundAmount}元</Descriptions.Item>
              <Descriptions.Item label="在线医助">{(info.assistantDoctor || {}).nickname}</Descriptions.Item>

            </Descriptions>
          </Card>
          <Divider dashed />
          {orderItemVos.length > 0 && <Tabs onTabClick={(key) => onTabsChange(key)} animated={false}>
            <TabPane tab="订单产品" key="1">
              <OrderTable
                data={orderItemVos}
                type={'service'}
                status={info.status}
                payments={payments}
                source={source}
                paymentPagination={paymentPagination}
                onPaymentPageNoChange={onPaymentPageNoChange}
                onReceivablesEdit={(type, item) => onReceivablesEdit(type, item)}
                onPaymentDelete={item => onPaymentDelete(item)}
              />
              <ReceivablesInfo
                status={info.status}
                info={info}
                payments={payments}
                source={source}
                pagination={paymentPagination}
                onChange={onPaymentPageNoChange}
                onEdit={(type, item) => onReceivablesEdit(type, item)}
                onDelete={item => onPaymentDelete(item)}
                onRefundEdit={onRefundEdit}
                continuePay={onContinuePay}
                onCancelPayment={onCancelPayment}
                loading={loading}
              />
              <UpgradeOrderInfo
                data={upgradeList}
              />
              <RefundInfo
                data={refundList}
              />
            </TabPane>
            <TabPane tab="预约信息" key="2">
              <ReserveInfo
                data={reserveList}
                reserveStatus={reserveStatus}
                pagination={reservePagination}
                onChange={onReservePageNoChange}
                source={source}
                assistantDoctor={(info.assistantDoctor || {}).nickname}
                consultantDoctor={(info.consultantDoctor || {}).nickname}
                personalDoctor={(info.personalDoctor || {}).nickname}
                onEdit={(type, item) => onReserveEdit(type, item)}
                onEditStatus={(data, customerId) => {
                  onEditStatus('updateReservationStatus', data, customerId)
                }}
                onAddReserveFollow={(data) => {
                  onAction('follow', 'add', {
                    customerId: info.customerId,
                    customerName: info.customerName,
                    ...data
                  })
                }}
              />
            </TabPane>
            {/* <TabPane tab="收款信息" key="3">
              <ReceivablesInfo
                status={info.status}
                payments={payments}
                source={source}
                pagination={paymentPagination}
                onChange={onPaymentPageNoChange}
                onEdit={(type, item) => onReceivablesEdit(type, item)}
                onDelete={item => onPaymentDelete(item)}
              />
            </TabPane>
            <TabPane tab="退款信息" key="4">
              <RefundInfo
                data={refundList}
              />
            </TabPane> */}
          </Tabs>}
          {drugOrderItemVos.length > 0 && <Tabs onTabClick={(key) => onTabsChange(key)} animated={false}>
            <TabPane tab="订单产品" key="1">
              <OrderTable data={drugOrderItemVos} type={'drug'} />
            </TabPane>
            <TabPane tab="收款信息" key="2">
              <ReceivablesInfo
                status={info.status}
                info={info}
                payments={payments}
                source={source}
                pagination={paymentPagination}
                onChange={onPaymentPageNoChange}
                onEdit={(type, item) => onReceivablesEdit(type, item)}
                onDelete={item => onPaymentDelete(item)}
                onRefundEdit={onRefundEdit}
                continuePay={onContinuePay}
                onCancelPayment={onCancelPayment}
                loading={loading}
              />
            </TabPane>
            <TabPane tab="物流信息" key="3">
              <LogisticsInfo
                logistics={logistics}
                pagination={logisticsPagination}
              />
            </TabPane>
          </Tabs>}
        </div>
      </Spin>
      {/* 扫码支付 */}
      <ScanCodePayment {...ScanCodePaymentProps} />
      {/* 编辑订单来源 */}
      <UpdateSource {...updateSourceProps} />
      {/* 编辑协助心理师 */}
      <UpdateAssistant {...updateAssistantProps} />
    </Drawer>
  )
}

export default OrderDrawer
